import PropTypes from 'prop-types';

import { Button, Layout, ModalV2 as Modal } from '@utilities';

import CreditCard from './components/CreditCard';
import PlanCard from './components/PlanCard';

import { payWithCompletes, payWithCredits } from '../../../../../Checkout/helpers/constants';

import styles from './_index.module.scss';

const ModalLaunchMethodType = ({
  creditsTotal,
  isOpen,
  launchMethod,
  onClose,
  onConfirm,
  setLaunchMethod,
  subscription,
}) => {
  const handleSelect = (method) => {
    setLaunchMethod(method);
  };

  return (
    <Modal
      buttons={[
        <Button key="cancel" onClick={onClose} text="Cancel" variant="secondary" />,
        <Button
          key="confirm"
          onClick={() => onConfirm(launchMethod)}
          text="Confirm"
          variant="primary"
        />,
      ]}
      isActive={isOpen}
      onClose={onClose}
      size="large"
      title="Launch Method"
    >
      <Layout.Flex className={styles['modal-launch-method-type']} direction="row" gap="medium">
        <PlanCard
          isSelected={launchMethod === payWithCompletes.key}
          onClick={
            subscription?.currentPeriod?.remainingCompletes <= 0
              ? undefined
              : () => handleSelect(payWithCompletes.key)
          }
          subscription={subscription}
        />
        <CreditCard
          isSelected={launchMethod === payWithCredits.key}
          onClick={creditsTotal === 0 ? undefined : () => handleSelect(payWithCredits.key)}
        />
      </Layout.Flex>
    </Modal>
  );
};

ModalLaunchMethodType.propTypes = {
  creditsTotal: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  launchMethod: PropTypes.oneOf([payWithCompletes.key, payWithCredits.key]),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  setLaunchMethod: PropTypes.func,
  subscription: PropTypes.shape({
    currentPeriod: PropTypes.shape({
      remainingCompletes: PropTypes.number,
    }),
    monthlyCompletesTotal: PropTypes.number.isRequired,
    monthlyCompletesUsed: PropTypes.number.isRequired,
    periodEndDate: PropTypes.string.isRequired,
  }),
};

export default ModalLaunchMethodType;
